export default "__VITE_ASSET__77fa6019__"